import { BaseModel } from '../../_base/crud';

export class ConfigDebt extends BaseModel {

    id: number;
    effectiveDate: string;
    orderDueDays: number;
    firstDebtDays: number;
    secondDebtDays: number;
    firstDebtInterest: number;
    debtAmountLimit: number;
    secondDebtInterest: number;

    /**
     * @description
     *  La cantidad de milisegundos que la fecha efectiva representa, contando
     *  desde el 1° de Enero de 1970, utilizando la zona de tiempo UTC+0.
     *
     * @param configuration
     *  La configuración de deuda.
     *
     * @returns
     *  La cantidad de milisegundos, o 0 si la fecha efectiva es 'undefined'.
     */
    public static effectiveDateToMilliseconds(configuration: ConfigDebt): number {
        if (configuration.effectiveDate === undefined) {
            return 0;
        }
        else {
            return new Date(configuration.effectiveDate).getTime();
        }
    }
}
